import React, { Fragment, } from 'react';
import { keyBy, } from 'lodash';

import useCollectionSubscription from '../hooks/useCollectionSubscription';
import Page from '../hocs/Page';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import MacroFormModal from '../modals/MacroFormModal';
import { conditionFieldTypes, conditionOperators, actionTypes, macroShippingOptions, } from '../../shared/models/macros';

export default Page(function Macros (props) {
  const { tenant } = props;
  const products = useCollectionSubscription(tenant.ref.collection('products').orderBy('createdAt'), [tenant.id]);
  const productsById = keyBy(products, 'id');
  const macrosRef = tenant.ref.collection('macros');
  const macros = useCollectionSubscription(macrosRef.orderBy('createdAt', 'desc'), [tenant.id]);

  const renderCondition = (condition) => {
    const fieldLabel = conditionFieldTypes[condition.fieldType]?.label ?? condition.fieldType;
    const opLabel = conditionOperators[condition.fieldType]?.[condition.operator]?.label ?? condition.operator;
    const product = productsById[condition.productId];
    const valueLabel = ({
      product: () => product ? `${product.sku ? `[${product.sku}] ` : ''}${product.name ?? ''}` : '(未選択)',
      postalCode: () => (condition.postalCodes || '').split('\n').filter(_ => _.trim()).join('、'),
    })[condition.fieldType]?.() ?? '';
    return `${fieldLabel} ${opLabel} ${valueLabel}`;
  };

  const renderAction = (action) => {
    const label = actionTypes[action.type]?.label ?? action.type;
    if (action.type !== 'addShippingOptions') return label;
    return `${label} ${(action.shippingOptionValues || []).map(_ => macroShippingOptions[_]?.label ?? _).join('、')}`;
  };

  return (
    <div className="macros container-fluid">
      <div className="p-4 bg-white my-4">
        <div className="alert alert-info">
          受注取込時に条件に一致する注文へアクションを適用します。
        </div>
        <div className="d-flex justify-content-start mb-2">
          <AddButton
            itemRef={macrosRef.doc()}
            FormModal={MacroFormModal}
            initialValues={{}}
            formProps={{ products }}
          />
        </div>
        <div className="mt-3 overflow-auto position-relative" style={{ zIndex: 0 }}>
          {
            macros.length > 0 ? (
              <table className="table sticky-table table-sm table-bordered">
                <thead className="thead-light text-center">
                  <tr className="text-nowrap">
                    <th style={{ minWidth: 150 }}>マクロ名</th>
                    <th style={{ minWidth: 80 }}>有効</th>
                    <th style={{ minWidth: 300 }}>条件</th>
                    <th style={{ minWidth: 250 }}>アクション</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    macros.map((macro) => {
                      const { id, ref, name, isEnabled, conditions = [], actions = [], } = macro;
                      return (
                        <tr key={id}>
                          <td>{name}</td>
                          <td className="text-center">{isEnabled ? '✓' : ''}</td>
                          <td>
                            {
                              conditions.map((c, i) => (
                                <div key={i}>{renderCondition(c)}</div>
                              ))
                            }
                          </td>
                          <td>
                            {
                              actions.map((a, i) => (
                                <div key={i}>{renderAction(a)}</div>
                              ))
                            }
                          </td>
                          <td className="text-right text-nowrap">
                            <EditButton className="ml-2" itemRef={ref} FormModal={MacroFormModal} formProps={{ products }} />
                            <DeleteButton item={macro} itemRef={ref} className="ml-2" />
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            ) : (
              <div>
                マクロは未登録です
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
});
